import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ACCOUNTING_EXPORTS } from "../../../../../utils/data/models";
import { reduxForm } from "redux-form";
import * as dataActions from "../../../../../utils/data/dataActions";
import AccountingExportsDataTable from "./AccountingExportsDataTable";
import { isEqual } from "lodash";
import { FormattedMessage } from "react-intl";
import { MessageBox } from "../../../../common";

class AccountingExportsFields extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.props.dataActions.clearDataList(ACCOUNTING_EXPORTS);
    this.getData();
  }

  getData() {
    this.props.dataActions.getDataList(
      ACCOUNTING_EXPORTS,
      0,
      0,
      "",
      ["exports.exportId:desc"],
      [
        `export_configurations.type==FINANCIAL`,
        `export_configurations.format==ACOMBA`,
      ],
    );
  }

  render() {
    return (
      <div>
        <div className="flex">
          <span className="message-alert">
            <MessageBox key="periodAlert" className="alert-warning">
              <FormattedMessage id="accountingExport.warning" />
            </MessageBox>
          </span>
        </div>
        <AccountingExportsDataTable />
      </div>
    );
  }
}

AccountingExportsFields.propTypes = {
  items: PropTypes.array,
  dataActions: PropTypes.object,
};

AccountingExportsFields = reduxForm({
  form: "Accounting Export",
})(AccountingExportsFields);

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

function mapStateToProps(state) {
  const data = state.data.accountingExports || {};
  return {
    items: data.items || [],
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccountingExportsFields);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exports/accounting/AccountingExportsFields.js